<template>
    <div class="popup-callback popup-all">
        <div class="popup-container">
            <div class="popup-vue has-header">
                <div class="popup-header">
                    <img class="popup-logo" src="/img/credit-landing-vue/popup-logo.svg">
                    <div class="popup-tel" v-html="__t('телефон для передзвону')"></div>
                </div>
                <button class="popup-close" ref="popupCallbackClose" @click="popupClose()" style="background: transparent;">
                    <img src="/img/credit-landing-vue/popup-close.svg" alt="Close">
                </button>
                <div class="popup-title">{{__t('Потрібна допомога')}} <br> {{__t('чи виникли питання?')}}</div>
                <div class="popup-description" v-html="__t('Залиште ваш номер телефону і ми вам перетелефонуємо')"></div>
                <form @submit.prevent="" id="callback-popup-form">
                    <div class="popup-inputs">
                        <div class="input-field">
                            <label for="callback_name">{{__t('Ім’я для передзвону')}}</label>
                            <input type="text" id="callback_name" name='name' v-model="name" v-lettericOnly>
                        </div>
                        <div class="input-field">
                            <label for="callback_phone">{{__t('Номер телефону для передзвону')}}</label>
                            <input type="text" id="callback_phone" @input="hideBackEndError"  inputmode="tel" v-model="client_phone" name='phone' v-mask="'+380(##) ###-####'">
                            <div v-show="validationFlag">
                                <label class="error_back" style="color: red"
                                       v-for="error in errorValidation.phone">{{error}}</label>
                            </div>
                        </div>
                        <input type="hidden" ref="inactive_time" name="time">
                        <input type="hidden" name="form_type" value="cash">
                        <input type="hidden" name="landing_type" value="cash">
                        <div data-size="invisible" class="g-recaptcha" id="g-recaptcha-callback-popup"></div>
                        <input type="hidden" name="g-recaptcha-response" class="g-recaptcha-response" :value="responseRecaptcha">
                    </div>
                    <button class="popup-button btn violet-btn" @click.once="clickButton">{{__t('Відправити')}}</button>
                </form>
                <div class="and-more more-text" v-html="__t('або зателефонуйте нам самостійно для передзвону')"></div>
                <div class="and-more" v-html="__t('телефон для передзвону')"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'popup-callback',
        props: [
            'client_name',
            'phone'
        ],
        data() {
            return {
                errorValidation: {},
                validationFlag : false,
                name: "",
                client_phone: "",
                responseRecaptcha: null,
            }
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            popupShow: function() {
                this.$el.style.display = 'block';
                this.updateData();

                this.$nextTick(() => {
                    this.$refs.popupCallbackClose.focus();
                });
            },
            popupClose: function() {
                this.$el.style.display = 'none';
            },

            validation: function() {
                let $this = this;

                $('#callback-popup-form').validate({
                    rules: {
                        name: "required",
                        phone: {
                            required: true,
                            minlength: 17,
                            mobileValidate: true,
                        },
                    },
                    messages: {
                        name: __t("Це поле обов’язкове. Заповніть його"),
                        phone: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                            minlength: __t('Номер телефону складається з 12 цифр'),
                            maxlength: __t('Номер телефону складається з 12 цифр'),
                            mobileValidate: __t('Некоректний формат номеру телефона'),
                        }
                    },
                    errorPlacement: function(error, element) {
                        error.insertAfter(element);
                        element.css('border-color', 'red');
                        $this.hideBackEndError();
                    },
                    submitHandler: function(form) {
                        grecaptcha.ready(function () {
                            grecaptcha.execute(process.env.CAPTCHA_APP_KEY, {action: 'form'}).then(function (token) {
                                $this.responseRecaptcha = token;
                                $this.$emit('openPreloader');
                                setTimeout(()=> {
                                    $this.saveData($(form).serialize(),'/credit_card_landing/apply_help');
                                    form.reset();
                                }, 500);
                            });
                        });
                    }
                });
            },
            saveData: function (formData, route) {
                let axiosConfig = {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                };

                let localeUrl = window.location.origin;
                let  url =  localeUrl + route;
                let $this = this;


                axios.post( url, formData, axiosConfig)
                    .then( (response) => {
                        $this.$emit('closePreloader');
                        $this.$emit('popup-success', 'response', response.data.status, response.data.message );
                    })
                    .catch(function (error) {
                        $this.errorValidation = error.response.data;
                        $this.validationFlag = true;
                        $this.$emit('closePreloader');

                    });
            },
            clickButton: function() {
                this.$emit('clicked');
            },
            hideBackEndError(el) {
                this.validationFlag = false;

            },
            updateData(){
                this.name = this.client_name;
                this.client_phone = this.phone;

            },

            setBubbleListener() {
                const bubbleBtn =  document.querySelector('#chat-bubble');
                if (bubbleBtn) {
                    bubbleBtn.addEventListener('click', () => {
                        this.popupShow();
                    })
                }
            }
        },
        mounted: function () {
            this.validation();
            this.setBubbleListener();
        }
    }
</script>